import {mutationTypes} from '@/core/constants'

export default {

    [mutationTypes.ATENDIMENTO.SET_FILTROS_BUSCA_TODOS_ATENDIMENTOS](state, filtros) {
        state.resultadoBuscaTodosAtendimentos.filtros = filtros
    },

    [mutationTypes.ATENDIMENTO.SET_PAGINACAO_BUSCA_TODOS_ATENDIMENTOS](state, paginacao) {
        state.resultadoBuscaTodosAtendimentos.paginacao = paginacao
    },

    [mutationTypes.ATENDIMENTO.RESETA_PAGE](state) {
        state.resultadoBuscaTodosAtendimentos.paginacao.page = 1
    },

    [mutationTypes.ATENDIMENTO.PROCEDIMENTO.SET_FILTROS_BUSCA_TODOS_PROCEDIMENTOS](state, filtros) {
        state.resultadoBuscaTodosProcedimentos.filtros = filtros
    },

    [mutationTypes.ATENDIMENTO.PROCEDIMENTO.SET_PAGINACAO_BUSCA_TODOS_PROCEDIMENTOS](state, paginacao) {
        state.resultadoBuscaTodosProcedimentos.paginacao = paginacao
    },

    [mutationTypes.ATENDIMENTO.PROCEDIMENTO.RESETA_PAGE](state) {
        state.resultadoBuscaTodosProcedimentos.paginacao.page = 1
    },

}